<template>
   <div class="container containerBox">
       <div class="auth-warper">
            <div class="user-box">
                <el-card style="height:100%;">
                    <p class="user-title">
                        权限分组
                        <el-button icon="el-icon-plus" size="mini" @click="handleAddGroup" style="float: right;">新增分组</el-button>
                    </p>
                    <ul class="user-list">
                        <li v-for="(v, i) in groupNameList" :key="v.OID" :class=" i===choseIndex ? 'active' : ''"  @click="handleChose(i, v)">
                            <span>{{v.Groupname}}</span>
                            <div class="fr">
                                <el-button type="text" size="mini" @click="handleEditRole(v)" circle plain icon="el-icon-edit"></el-button>
                                <el-button type="text" size="mini" @click="handleDetelRole(v)" circle plain icon="el-icon-delete"></el-button>
                            </div>
                        </li>
                    </ul>
                    <p class="nodata" v-if="groupNameList.length==0">暂无分组</p>
                </el-card>
            </div>
            <div class="auth-box">
                <el-card style="height:100%;">
                    <p class="user-title">权限列表</p>
                    <ul class="module-list">
                        <li v-for="(v, i) in moduleList" :key="i">
                            <span>
                                <span class="auth-name">{{v.ModuleName}}</span>
                                <span style="flex:1;">
                                    <el-radio-group v-model="v.Module_value" :disabled="true">
                                        <el-radio :label="0">不可见</el-radio>
                                        <el-radio :label="1">可读</el-radio>
                                        <el-radio :label="2">可操作</el-radio>
                                    </el-radio-group>
                                </span>
                            </span>
                        </li>
                    </ul>
                    <p class="nodata" v-if="groupNameList.length==0">暂无分组</p>
                </el-card>
            </div>
       </div>
        <!-- 添加分组 -->
        <cmp-add-authority :modeldata="dataList" :modelShow.sync="modalVisible"></cmp-add-authority>
   </div>
</template>

<script>
import { mapGetters } from "vuex";
import Service from '@/api/Service';
import { fmtObjToArr } from '@/utils/array'
import CmpAddAuthority from './CmpAddAuthority'
import {$Alert} from '@/utils/utils'
export default {
    name: 'authority',
    inject: ["reload"],
    data() {
        return {
            choseIndex: 0,

            groupNameList: [],  //  分组名称集合
            moduleList: [], //  权限

            // 添加弹框
            defaultModuleList: [],  //  权限模块
            modalVisible: false,
            dataList: {},
        }
    },
    components: {
        CmpAddAuthority
    },
    created() {
        // 获取权限模块
        this.$store.dispatch("getRoleModule").then(res=>{
            this.defaultModuleList = res;
            // 获取权限分组
            this.getRoleGroupList();
        })
    },
    computed: {
        // 项目，项目列表
        ...mapGetters(['baseData', "user"])
    },
    methods: {
        // 获取权限分组
        async getRoleGroupList() {
            let assigned_user_id = this.user.oid;
            let data = await Service.getRoleGroupList({assigned_user_id: assigned_user_id});
            data = data =='success' ? [] : data;
			
            if(data.length>0) {
               data.map(v=>{
                   v.moduleList = fmtObjToArr(JSON.parse(v.Allowed), this.baseData.roleModule)
               })
               this.groupNameList = data
            //    this.moduleList = data[this.choseIndex].moduleList
               this.handleChose(this.choseIndex, data[this.choseIndex])
            }
        },
        // 切换权限分组
        handleChose(i, v) {
            this.choseIndex = i;
            let arr = JSON.parse(JSON.stringify(this.defaultModuleList))
            arr.map(obj=>{
                v.moduleList.map(v1=>{
                    if(obj.ModuleKey === v1.ModuleKey) {
                        obj.Module_value = v1.Module_value
                    }
                })
            })
            this.moduleList = arr;
        },
        // 新增分组
        handleAddGroup() {
            this.modalVisible = true;
            this.dataList = {
                moduleList: this.defaultModuleList
            };
        },
        // 分组名称
        handleEditRole(v) {
            let arr = JSON.parse(JSON.stringify(this.defaultModuleList))
            arr.map(obj=>{
                v.moduleList.map(v1=>{
                    if(obj.ModuleKey === v1.ModuleKey) {
                        obj.Module_value = v1.Module_value
                    }
                })
            })

            this.modalVisible = true;
            this.dataList = {
                name: v.Groupname,
                moduleList: arr,
                oid: v.OID,
            };
        },
        // 删除分组
        handleDetelRole(v) {
            $Alert(`是否确认删除 ${v.Groupname} `).then( async (bool)=>{
                if(bool){
                    let data = await Service.getDeletRoleGroup({ oid: v.OID });
                    if(data) {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                        });
                        // 刷新列表数据
                        this.reload();
                    }
                }
            });
        },
    },
}
</script>
<style scoped lang="less">
    .auth-warper{
        display: flex;
        width: 100%;
        display: -webkit-flex;
        flex-direction: row;
        background: #fff;
    }
    .user-box{
        width: 300px;
        margin-right: 20px;
    }
    .user-list li{
        line-height: 36px;
        font-size: 14px;
        border-bottom: 1px solid #ccc;
        cursor: pointer;
        position: relative;
        .fr{
            display: none;
        }
        .add-icon{
            line-height: 47px;
            margin-left: 10px;
            font-size: 20px;
            color: @primary-color;
        }
    }
    .user-list li:hover{
        color: @primary-color;
        .fr{
            display: block;
        }
    }
    .user-list li::after{
        position: absolute;
        content: "";
        left: 0;
        bottom: -1px;
        width: 0;
        height: 1px;
        /* -ms-transform: translateX(-50%);
        transform: translateX(-50%); */
        background-color: @primary-color;
        transition: all .3s ease;
    }
    .user-list li:hover::after{
        width: 100%;
    }
    .user-list li.active{
        color: @primary-color;
        border-bottom: 1px solid @primary-color;
    }
    .auth-box{
        flex: 1;
    }
    .user-title{
        margin:0 0 15px 0;
        color: #1f2f3d;
        font-size: 20px;
    }
    .auth-name{
        display: inline-block;
        vertical-align: middle;
        width: 300px;
    }
    .module-list{
        margin: 0 20px;
        li{
            line-height: 32px;
            padding-left: 20px;
            &:nth-child(2n-1){
                background-color: #f5f7fa; 
            }
            &:hover{
                background-color: #f5f7fa;
            }
        }
    }
</style>
